import {
    CREATEENTITYMAPPING_SUCCESS,
    CREATEENTITYMAPPING_FAILED,
    RESET_CREATEENTITYMAPPING,
    LOADING_CREATEENTITYMAPPING,
    NETWORK_ERROR_CREATEENTITYMAPPING,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetCreateEntityMappingList = () => {
    return { type: RESET_CREATEENTITYMAPPING };
};

const createEntityMappingList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_CREATEENTITYMAPPING });
    await adminServices
        .post("createEntityMapping", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(createEntityMappingListsuccess(res.data));
                    break;
                default:
                    dispatch(createEntityMappingListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_CREATEENTITYMAPPING, payload: err });
        });
};
function createEntityMappingListsuccess(data) {
    return {
        type: CREATEENTITYMAPPING_SUCCESS,
        payload: data,
    };
}
function createEntityMappingListFailed(data) {
    return {
        type: CREATEENTITYMAPPING_FAILED,
        payload: data,
    };
}

export { resetCreateEntityMappingList, createEntityMappingList };
